import React from 'react';
import { useSelector } from 'react-redux';

export default function useReceiveSelector() {
  const ReceiveListData = useSelector((state) => state.Receive.list_data?.content) || []; // List data
  const ReceiveRecordData = useSelector((state) => state.Receive.record_data) || []; // record data
  const InvoiceListData = useSelector((state) => state.Receive.invoice_list_data) || []; // List data
  //   const ReceiveCommentLog =
  //     useSelector((state) => state.Receive.comment_log?.partnerReceiveCommentLogs) || []; // comment log

  return { ReceiveListData, ReceiveRecordData, InvoiceListData };
}
